import React from "react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, RefreshCw } from "lucide-react";
import { isChunkLoadFailure } from "@/lib/lazyWithRetry";

/**
 * Error Boundary para capturar erros de renderização e evitar tela branca.
 * Exibe mensagem amigável e botão para recarregar.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Erro capturado:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const err = this.state.error;
      const chunkStale = err && isChunkLoadFailure(err);
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-blue-50">
          <div className="max-w-md w-full">
            <Alert variant="destructive" className="border-2">
              <AlertCircle className="h-5 w-5" />
              <AlertTitle>
                {chunkStale ? "Nova versão disponível" : "Algo deu errado"}
              </AlertTitle>
              <AlertDescription>
                <p className="mb-4">
                  {chunkStale
                    ? "Foi publicada uma nova versão da aplicação. Recarregue a página para carregar os ficheiros atualizados."
                    : "A página encontrou um erro inesperado. Isso pode ser temporário."}
                </p>
                <Button onClick={this.handleReload} className="gap-2">
                  <RefreshCw className="w-4 h-4" />
                  Recarregar página
                </Button>
              </AlertDescription>
            </Alert>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
